import { getFirebase } from '~/firebase'
import { LevelActionType } from '~/bootcamp/types/bootcamp.types'

import { rewardApi } from '~/redux/apis/reward-api'
import { notificationApi } from '~/redux/apis/notification-api'
import { leaderboardApi } from '~/Leaderboard/apis/leaderboard-api'

import { bootcampSplitApi } from './split.api'

export interface Activity {
  type: number
  difficultyLevel?: number
  reward?: number
  gem?: string
  gemCount?: number
  xp?: number
}

interface BootcampEventData {
  activity?: Activity
  bootcampId: string
  moduleId: string
  levelId: string
  gymType: string
  awardMathEnergyOrbs?: number
  levelPage: LevelActionType
  round?: number
}

interface BossProgressArgs {
  category: string // Bootcamp Category e.g. 'numbers-and-quantities'
  subject: string // Bootcamp Subject e.g. 'multiplication'
  bootcampId: string // Bootcamp id e.g. '1', '2', '3' etc
}

const SetData = bootcampSplitApi.injectEndpoints({
  endpoints: (build) => ({
    setBootcampData: build.mutation<unknown, BootcampEventData>({
      queryFn: async (args, { dispatch }) => {
        const { activity, bootcampId, levelId, levelPage, moduleId, gymType, awardMathEnergyOrbs = 0, round } = args
        const { httpsCallable, functions } = await getFirebase()
        const status = await httpsCallable(
          functions,
          'setBootcampData',
        )({
          activity,
          bootcampId,
          levelId,
          levelPage,
          moduleId,
          gymType,
          awardMathEnergyOrbs,
          round,
        }).then(() => {
          dispatch(rewardApi.util.invalidateTags(['Rewards']))
          dispatch(notificationApi.util.invalidateTags(['notification']))
          dispatch(leaderboardApi.util.invalidateTags(['leaderboard']))
        })

        return {
          data: status,
        }
      },
      invalidatesTags: ['ActivityData', 'List', 'Overview'],
    }),
    // To send data of boss defeated in a bootcamp for badge update in backend
    setBossProgress: build.mutation<unknown, BossProgressArgs>({
      query: ({ category, subject, bootcampId }) => ({
        url: '/v1/badge',
        method: 'POST',
        body: {
          featureId: [category, subject, bootcampId].join('_'),
        },
      }),
    }),
  }),
  overrideExisting: false,
})

export const { useSetBootcampDataMutation, useSetBossProgressMutation } = SetData
